import React from 'react';
import {
  Card,
  CardHeader,
  CardTitle,
  Table,
  Button,
  Spinner
} from 'reactstrap';
import { Link } from 'react-router-dom';
import getLangData from '../../../utils/getLangData';
import langText from '../../../utils/langText';
import { hashRoute } from '../../../utils/transform';
import Cookies from 'js-cookie';

const ProductComp = props => {
  const { customer = false } = props;
  const {
    actions,
    main_image,
    name,
    price,
    status,
    date,
    total_views
  } = getLangData().components.products;
  return (
    <Card>
      <CardHeader>
        <div className='d-flex justify-content-between align-items-center'>
          <CardTitle className='mb-0 text-bold'>{props.cardTitle}</CardTitle>
          {props.children}
        </div>
      </CardHeader>
      <Table responsive className='text-center'>
        <thead>
          <tr>
            <th>{main_image}</th>
            <th>{name}</th>
            {!customer && <th>{total_views}</th>}
            <th>{date}</th>
            {/* <th>{total_views}</th> */}
            {!customer && <th>{status}</th>}
            {customer && <th>{getLangData().general_words.category}</th>}
            <th>{price}</th>
            <th>{ }</th>
          </tr>
        </thead>

        <tbody>
          {props.isLoading && (
            <div className='d-flex justify-content-center w-100'>
              <Spinner />
            </div>
          )}
          {props.items?.map((item, i) => {
            let button;
            if (!item.hasStaging) {
              button = (
                <Button color='success' className='btn-round'>
                  {getLangData().components.products.active}
                </Button>
              );
            } else {
              button = (
                <Button color='warning' className='btn-round'>
                  {getLangData().components.products.pending}
                </Button>
              );
            }
            const date = new Date(item.createdAt);

            return (
              <tr key={i}>
                <td>
                  {item?.productImages[0]?.imagePath && (
                    <img
                      src={item.productImages[0].imagePath}
                      style={{ maxWidth: '70px' }}
                      className='media-object round-media height-50'
                      alt='Card cap 02'
                    />
                  )}
                </td>
                <td style={{ width: '250px' }}>
                  {langText(item.name, item.namei18n, getLangData().lang_code)}
                </td>
                {!customer
                  && <td>
                    {item.totalViews}
                  </td>}
                <td>
                  {date.getDate() +
                    ' - ' +
                    date.getMonth() +
                    ' - ' +
                    date.getFullYear()}
                </td>

                {customer ? (
                  <td>
                    {langText(
                      item.categoryData[0].name,
                      item.categoryData[0].namei18m,
                      getLangData().lang_code
                    )}
                  </td>
                ) : (
                  <td>{button}</td>
                )}
                <td>
                  {item.priceFrom === item.priceTo
                    ? item.priceFrom
                    : `${item.priceFrom} - ${item.priceTo}`}
                </td>
                <td className='danger'>
                  {customer ? (
                    <a
                      href={`${props.edit}/${langText(
                        item.name,
                        item.namei18n,
                        getLangData().lang_code
                      ).toLowerCase()}/${item._id}`}
                      target='_blank'
                    >



                      <Button color='link' >
                        {customer
                          ? getLangData().components.actions.view
                          : getLangData().components.actions.edit}
                      </Button>
                    </a>
                  ) : (
                    <Link to={`${props.edit}/${item._id}`}>
                      <Button color='link'>


                        {customer
                          ? getLangData().components.actions.view
                          : getLangData().components.actions.edit}
                      </Button>
                    </Link>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </Card>
  );
};

export default ProductComp;
